import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import UserProfile from '../components/UserProfile';

export default function ProfilePage() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="px-4 pt-6 pb-20">
      {isAuthenticated ? (
        <UserProfile />
      ) : (
        <div className="pt-8 text-center">
          <div className="text-6xl mb-6">👋</div>
          <h2 className="text-text-dark text-xl font-semibold mb-4">
            Welcome to Daddy Time
          </h2>
          <p className="text-text-medium text-sm mb-8 leading-relaxed">
            Sign in to access your profile, track your sessions, and unlock exclusive content.
          </p>
          <button
            onClick={() => navigate('/signin')}
            className="bg-primary-pink hover:bg-pink-400 text-white font-medium py-3 px-6 rounded-xl transition-colors"
          >
            Sign in
          </button>
        </div>
      )}
    </div>
  );
}